<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/zNoPpc/tc-custom/9781488004001.jpg?1705766128031" alt="This image is the cover for the book Earl in Want of a Wife, The Eastway Cousins"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Earl in Want of a Wife, The Eastway Cousins
      </h1>
      <p class="bookDescription body article font2">
        <b>In this Regency-era romance, a nobleman proposes marriage a convenience for financial reasons, then discovers the wife he is falling for is penniless. </b><br/><br/>The Earl of Burwell needs a wife! The woman who broke Daniel’s heart has been blackmailing him, so to protect his son from the horrors of illegitimacy, he must find a rich bride . . . <br/><br/>Temporarily posing as her heiress cousin, plain, poor orphan Lizzie Eastway knows her popularity is due only to her supposed dowry—no one could ever love the real her. And disclosing her true identity seems heartbreakingly impossible when Lizzie sees the spark of genuine desire in dashing Lord Burwell’s eyes!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Laura Martin
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6f527ba2